'use client';

import { ThemeProvider } from '@mui/material/styles';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import GlobalSnackbar from './common/GlobalSnackbar';
import theme from '@/lib/theme/theme';
/**
 * ThemeRegistry component provides Material-UI theming and CSS caching for the application.
 *
 * This component wraps the application with necessary providers:
 * - AppRouterCacheProvider: Handles CSS injection for MUI with Next.js App Router
 * - ThemeProvider: Provides the custom theme configuration to all child components
 *
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to be wrapped with theme providers
 * @returns {React.JSX.Element} ThemeRegistry component
 *
 * @example
 * ```tsx
 * <ThemeRegistry>
 *   <App />
 * </ThemeRegistry>
 * ```
 */
export default function ThemeRegistry({ children }: { children: React.ReactNode }) {
  return (
    <AppRouterCacheProvider>
      <ThemeProvider theme={theme}>
        {children}
        <GlobalSnackbar />
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
